import performRequest from "./requestHelpers";
import { BaseAddress } from "../config";

export default function requestAdmin(url, option) {
  return performRequest(BaseAddress.CcAdmin + url, option);
}
